import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/payment/result")({
  component: RouteComponent,
});

function RouteComponent() {
  useEffect(() => {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({ type: "PAYMENT_SUCCEEDED" }, window.location.origin);
    }
    window.close();
  }, []);

  return (
    <div className="flex items-center justify-center w-full h-screen">
      <div
        className="animate-spin h-8 w-8 rounded-full border-2"
        style={{
          border: "2px solid transparent",
          background:
            "linear-gradient(white, white) padding-box, linear-gradient(to right, #e5e7eb, #9ca3af) border-box",
        }}
      />
    </div>
  );
}
